import {useIncreasingNumber} from './useIncreasingNumber';
// One counter implementation for room pools, per-card shares and sales totals.
export function PrizeAmount({minor,formatter,settled}:{minor:number;formatter:Intl.NumberFormat;settled:boolean}){
 const shown=useIncreasingNumber(minor,formatter,settled,100);
 return <strong className="prize-amount">{shown}</strong>;
}
